import LightningComponent from "./Lightning";

export default LightningComponent;